import React from "react"
import "./modal-educational.scss"
import { infoModal } from "./infoModal"

const ModalEducational = ({ modalView = 0, handleNext }) => {
  console.log("this is modal view", modalView)

  return (
    <div className="modal-educational">
      <div className="modal-educational-container">
        <div className="wrapper-star">
          <div className="modal-educational__content">
            {infoModal[modalView].txt}
            <img src={infoModal[modalView].img} alt="Imagen vulva" />
            <button
              className="modal-educational__content__button btn-primary"
              onClick={() => {
                handleNext()
              }}
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalEducational
